<script lang="ts">
  import BoolBadge from './BoolBadge.svelte'
  import CountChip from './CountChip.svelte'
  import DateWidget from './DateWidget.svelte'
  import EmailWidget from './EmailWidget.svelte'
  import IdChip from './IdChip.svelte'
  import NullValue from './NullValue.svelte'
  import PhoneWidget from './PhoneWidget.svelte'
  import StatusPill from './StatusPill.svelte'
  import UrlWidget from './UrlWidget.svelte'
  import type { FieldType } from './detect'

  let {
    type,
    value,
    singular = 'item',
    plural = 'items',
  }: {
    type: FieldType
    value: unknown
    singular?: string
    plural?: string
  } = $props()
</script>

{#if type === 'date'}
  <DateWidget {value} />
{:else if type === 'email'}
  <EmailWidget {value} />
{:else if type === 'url'}
  <UrlWidget {value} />
{:else if type === 'phone'}
  <PhoneWidget {value} />
{:else if type === 'status'}
  <StatusPill {value} />
{:else if type === 'bool'}
  <BoolBadge {value} />
{:else if type === 'null'}
  <NullValue />
{:else if type === 'id'}
  <IdChip {value} />
{:else if type === 'count'}
  <CountChip {value} {singular} {plural} />
{/if}
